import styled from "styled-components";

export const LinkButton = styled.a`
  padding: 11px 21px;
  outline: none;
  border: none;
  border-radius: 0;
  background: ${props => props.color};
  color: ${props => props.theme.colors.transparent75};
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 6px 0 -2px ${props => props.theme.colors.primaryDark};
  transition: all 0.15s ease-out;
  &:hover {
    transform: translateY(-1px);
    color: ${props => props.theme.colors.transparent75Hover};
    box-shadow: 0 14px 0 -6px ${props => props.theme.colors.primaryDark};
  }
`;

export const Button = LinkButton.withComponent("button");

export const SimpleSwitch = styled.button`
  padding: 5px 7px;
  outline: none;
  border: none;
  transition: all 0.2s ease-out;
  background: ${props =>
    props.active ? props.theme.colors.success : props.theme.colors.lightGrey};
`;



// WEBPACK FOOTER //
// ./src/base/Buttons.js